module.exports = __webpack_public_path__ + "static/media/dkle2.bc1f502e.png";